import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .LinkPlanModal {
    overflow-y:inherit !important;
  }


  .PatientPlans__Spinner {
    margin-top: 200px;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 1060px) {
    justify-content: center;
    .PatientPlans__Title {
      font-size: 21px;
    }
  }
`

export const LinkPlanButton = styled.button`
  width: 100%;
  height: 188px;
  border: 2px dashed #C1C1C1;
  border-radius: 10px;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
`

export const PlansContainer = styled.div`
  width: 100%;
  margin: 20px 0 135px 0px;
	column-count: 2;
  gap: 20px;

  @media (max-width: 1050px) {
    column-count: 1 !important;
  }
`